var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGpsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 235.549 138.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.914,69.968,96.812,88.42l-9.335,43.589v.075l27.439-62.115h0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -2.044,
    y1: 1.653,
    x2: -2.019,
    y2: 1.653,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e24b94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    stopColor: "#b5358a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#902383"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.592,98.1l7.62.027.072-.073-7.667-.011Zm-26.476-.094,17.867.063v-.038l-17.867-.025.407-.089,17.43-7.935v-.069ZM86.28,82.96l-.025.056,28.661-13.048Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -0.737,
    y1: 2.36,
    x2: -0.723,
    y2: 2.36,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d81480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#dd318c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#e34e98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#e660a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#e867a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e96fa8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.519,97.92l0,0-.407.089,17.867.025-.014-3.942Zm28.96-6.355-2.862,6.479,2.64,0,5.08.007,9.475-9.635Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -1.176,
    y1: 4.825,
    x2: -1.153,
    y2: 4.825,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e04090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    stopColor: "#ac2d87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#902383"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.749,88.433l.063-.013,18.1-18.452Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.368,
    height: 18.717,
    transform: "translate(96.641 69.829)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "i",
    width: 1,
    height: 1,
    patternTransform: "matrix(1, 0, 0, -1, 0, 37.433)",
    viewBox: "0 0 18.368 18.717"
  }, /*#__PURE__*/React.createElement("image", {
    preserveAspectRatio: "none",
    width: 18.368,
    height: 18.717,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAFKADAAQAAAABAAAAFAAAAACRFdLHAAACG0lEQVQ4Ea2U6W7bMBAG1xYPxW4euo+WN+nPIm16RNbBQ1ZmV1bQogkQFzZAyKLM4fDblXfLssgtP85gSt3tbsH9vFdK/zRITVXkBrZm+Py1k3hKEj9FRhAXmf5PYwN2j53kPkjqkoRjkGDgKKHl8f66KAzYf+sBFgmHLFGBpyzpMEm8x1jvD+HDYAMOP3rxQ5bCwtxns4wHL4nvkbl4z8D6I2ADTr96qdFLGbO41gNlYObv2IBr4j4ciANoC1zn987q+U9nGHD8ORjIA2sMDHAoLMziT349th4d49Rxv2XMKfa++QtqwPR7lDNtU6diFVZLHXXEWo2JI1A0yxOwxpK0K3QThXPdwKvhE0fmGI6qzneApoophmrM8KOTgvEG9phFNsjk657XdrMojlHWDL/3mCTx7OQMrIZOKjDtSbu2ReYJY+wcmyosAPZaSE6QiEaLZsBlXmTGYFazlgU88CzShTNQfYsccaxg5gHXUY2BkHMZgCISjkS2JWpvHeB6ARfMnBoYmA0UjGXDvKdwDfNejYFqpmrq6YZX4AYW/nw24zPGNahxlqrHUbiBL8a6qd1fWu5N4CsZ8JkogJ7zjPklCgUDseKRs7vEoXM2/lj/7tcVPAOeOOJaFD2iAiwKzBsy9mr8LuWNBwpepllKwph333K0nNc45muB2x5awIUYlrJGUch4M94MH7YfX3O1zihnqTS3dgdd8eUFOEod7byCowgAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.745,96l-4.221,1.921L70.969,94.09l-.016-4.107Zm28.51-12.981-3.776,8.548,14.27-3.131,18.166-18.465h0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.634,
    height: 28.205,
    transform: "translate(53.375 69.829)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "l",
    width: 1,
    height: 1,
    patternTransform: "matrix(1, 0, 0, -1, 0, 56.411)",
    viewBox: "0 0 61.634 28.205"
  }, /*#__PURE__*/React.createElement("image", {
    preserveAspectRatio: "none",
    width: 61.634,
    height: 28.205,
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.524,97.918l0,0,17.45-3.83Zm43.225-9.485-14.27,3.131h0L96.812,88.42Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.527,
    height: 9.75,
    transform: "translate(53.375 88.284)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "o",
    width: 1,
    height: 1,
    patternTransform: "matrix(1, 0, 0, -1, 0, 19.5)",
    viewBox: "0 0 43.527 9.75"
  }, /*#__PURE__*/React.createElement("image", {
    preserveAspectRatio: "none",
    width: 43.527,
    height: 9.75,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAALCAYAAAAELW+PAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAALKADAAQAAAABAAAACwAAAACsRzaNAAACVUlEQVQ4Ec2Va3KbMBhFPywJ23FW1R12GVlGt9RMYgN69FyBCKWup9PmRzOj6IGEzr26yN3Ll6/Fus70d6B2R2fh0lt46s2fg/lTMHfyc32c+2086HktzGeN2o4SLkfr6Tvecehdffcn/fvm24sqcimWh2TTeLX8Nlp6CpbYXCD5HIGeLA2e0ltCSLoBTAnXyfJtsljhGaef3ngmERIu8OO6Vdvyr+qf3tItTluxBTyxebQMeGbzfPa4HawMkUINrEpmTMByN52ZR1u1B9yfx08FX4HnUJi1uskXXByjpXdcvHDkgsexxHjC8Tzi5AgkfSfQ6rbiwTOdDHOrgPfR4uL2vzjuW34b4L2apJgBPU0CH4HAOeCLnFUBzp3ILK4LXEVxSVdvUS4zxyPUsTYBXaOjqNGuGW8ne2/z3Vh1eOuq2vv+dk0eyfh0q+BJmVVUyLQ/4TAfZXUVQAFHchuq05wI8ALMCDgoOhvH9XE6ZfwPwD8isZu8667MVQyWF8DTlK0AUHBcGVeGCxGp+VaNAEUq3xDDTVPdv4YKLGHKuMAlRNC6abr+MfgKLKKts/f6K3VrCBzo+H2ozgmiPPcIoAgU1zM5l4jc4sKcgz5UwHVCEilBDd4RlUB8fgdegfegjedRvV+T5XYczNh867jyWyo443wHeSASyj1Fmfe6bZR5BCjnioyE6HfAPR+tC9zjm+P+xeEtSGtr/mbNehLrNbgo0/wSs6XX2fEaETmuqw6ossB6wOeoEKWbbpElMrS1xtUT4GPVVSlhm6h0pV4Bj7z8v579AMzLSso1OGVVAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.337,98.055l.124,34.029L96.812,88.42Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.663,
    height: 43.962,
    transform: "translate(87.24 88.284)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "r",
    width: 1,
    height: 1,
    patternTransform: "matrix(1, 0, 0, -1, 0, 87.924)",
    viewBox: "0 0 9.663 43.962"
  }, /*#__PURE__*/React.createElement("image", {
    preserveAspectRatio: "none",
    width: 9.663,
    height: 43.962,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAtCAYAAACXm/ozAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACqADAAQAAAABAAAALQAAAABrUWnbAAABwUlEQVQ4EdVUQW7DMAyTHaXtXr0v7Qv7zV7RjKQk1zEyoNcVSOuIFEkpQdtxHPbOx38+v95hfvd31Mj5D0S/GqZdFEW8AmzeLxbog7QAEp1qrs5aeQF1PyIc5vZE9QIYHB6Ah+JcXfvSBcRFsOxTST+o+Xh7JvurWiiWyiCPw7Dzg8PUNBNeJcWn9Wk9qrKPHWPD0pH1CagYJZn3scfQDz0ASlAxBvEPoATli6YYprpLeb1HfbIm68RQW+QncQWZKfn6mTMOIIuSWsRz4YvrRCqD3GPE4XcBqrABe2+7mz+fKsXXpKSO3qzd3PodROW7yraBdN9Fsn3L9cxEavtm7QElqBmuditiufM9oBVItORFtYbGsCYRVoYszBOkDSScQexSpErlgZKsAEopSZra9v4KTTtaQYHEznNe3j9uLysSkcdAnEkczttjDwVOShWQNITu8feZdVeRYJEwgDnipCWJVHdOKhIBZkuFIpKkhRPkYgsIIhWxKqnCnoodjylIrzzDIdV4j4yRryzHtKwjhvaJs0uNj0qhYVkxOFCe9WSahjnnYb7GB8Gc6aj1lJ1sNECtK4ek9ZgYVvVKVWPF4hy/Enadtv03W7QAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.612,90.58h0ZM56.826,76.1,42.613,90.58l-7.327,34.238v.046Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: -0.975,
    y1: 1.979,
    x2: -0.943,
    y2: 1.979,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffef84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#ffdd67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ffb020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffab18"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.312,98.109l26.765.1.056-.057L8.312,98.109l.32-.07L56.826,76.1Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: -0.111,
    y1: 2.791,
    x2: -0.092,
    y2: 2.791,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#ffe835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#ffed69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fff18f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#fff3a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#fff4af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff6ba"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.513,91.48,8.626,98.041l.006,0-.32.07,26.862.042,7.438-7.57Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: -0.225,
    y1: 5.933,
    x2: -0.197,
    y2: 5.933,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffeb60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308,
    stopColor: "#ffde4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.943,
    stopColor: "#ffbe15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffbb10"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.572,90.589l.041-.009h0l13.837-14.1ZM56.45,76.481l.376-.383Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.538,
    height: 14.712,
    transform: "translate(42.407 76.01)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aa",
    width: 1,
    height: 1,
    patternTransform: "matrix(1, 0, 0, -1, 0, 29.424)",
    viewBox: "0 0 14.538 14.712"
  }, /*#__PURE__*/React.createElement("image", {
    preserveAspectRatio: "none",
    width: 14.538,
    height: 14.712,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAD6ADAAQAAAABAAAADwAAAAAk/vkzAAABRUlEQVQoFZ2T8U7CMByEb6xdogj6/m/DG/gSmmj8Q0UYuI36XUcVFYlKsrQZve93d4UqpSFJE/3js5hofSP1S7S7P+uD2lupe5biXGoupXAB5HdOQp4cZyOgexwh0ZCpVMWTbhDfIXgZD3tqQ4TwxDv28YoH8A+QoM09U5kSzxEB6RBnIaLoPXHs5AgkpPYBUatqOJPqNYdWFGgIjyGN9+7EMMdhnTQ5DoXRdpgr9RysV6p6O9i78DtDnL+xmDiO5jhAxrZrFzVayxDElWN0uLD12nuLeLLYcaaIE/drmwOWOxdVIEwLa+IgrNnn7/dR9r2E97v4BPnqBEiJ0+PGMVg/xIWSIRwYWunVELdNJ7aLqIou1jGWR8SHEFvdASk/nlKsIfTyfXIRlzXxvxk2QLZAuLJuvDI7sXhRzp1cDyE9kDC7fgM3sY4qNh6XRAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.633,98.039l33.939-7.45L56.45,76.481l.376-.383Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ac"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.401,
    height: 22.198,
    transform: "translate(8.544 76.009)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ad",
    width: 1,
    height: 1,
    patternTransform: "matrix(1, 0, 0, -1, 0, 44.397)",
    viewBox: "0 0 48.401 22.198"
  }, /*#__PURE__*/React.createElement("image", {
    preserveAspectRatio: "none",
    width: 48.401,
    height: 22.198,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAXCAYAAACiaac3AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAMaADAAQAAAABAAAAFwAAAAAMuHZhAAAEnUlEQVRYCdWXCW4cNxQFydbIOxL7Srn/TYzEgBDb2oZM1ecitqJlbAcCMgbNtclXfPzsVq61pv/77yDA5ec/GknO1N6mlD+Sfkt5+0D+PlLe3qWaPtD2PuVMTrttjrGcbKOe0rlTvugvIOaK4co3qt9Tql9SrcJ8DKG1InS7SqlcpZrJ8yXjLhlzDcQlY3xmALMRLwizhxg0AYMoRKZ6gdDfEf0p5XqVSggW4hpnrgC4pgwYfRnInIXRIVzJLwPzMMS/YBBdvyEUgTrA7tcNBxJ5vomUdQeQtNHPGMfGccsD5umlxpI/k580cy0b4m5SLn+yhjDsuACklG/ZfUA8aumG42ZbTzhVcbPBGGtvGHPSkj/EcsKMBHsE/IYgigqtf6V6RFzsvE7oSnMkASSwbkWyHrA69JaphHn9n8I8A6FwXIjkzTXK5replovIPUoRH4qPdvIQj0tRX9wJl14DgyvhzBnP/NrvGYguPLNQzQhaIVw8c7Tc9QtKCO1uZGCinaOWNpJjLEfd8TghpA7qSjjz8zBPQOjCuvsDCJDcYHRJtGy96szf9JHHTQUILqSieARTbq50oKgbV0IZV7xfAsa5f+z3BAQTVSbcFDhcWKFcbNTXXFFfAVKYt1eHyEfmItUj7YV2yt2dLHh6FZCJPAkUrp8G8whEj4W+41Os9Wg7ay5FwAtAivYFBrGVmywlRMdNhuii8EJboQ2Q6Ks414GEDIcA8RY7EeYRCOZg99PWYiFE7uKhCTdG4iiNvg7lMWzxw7gOkxEsUEW8ue3hjPWKC1uBsaQNh5p7w5nnYR6BYPG5swoCJuoeodWlBrP22R8Aq0tCBoxv83GUcKjgAv/yxv+UeRAkAW+B4YhFnJzTzJF8wpkHINZrtYlWWKQJIhj/Jqj9Dai5YLm3DZj5rDv/vR0hdj/nOwCf8pvLmCmAeLQ2brbnYB6AcCKm212rQ5TX4BA8RI7cMQ1udfH++AxU9ajqQbwQfazdg7aFUxEbB2Y74oxrdpjNWNEZ3Ip4aXruQawuNFHTgdjR1q8DexcaSLtyB+Td86KlECPA6CePTwCFc4uZGfQco60oltjYwZzTrnjfQV7H3n7KP3vgQyauVQjnteqiJqmHsJH3PquMiWwdM46brka74x1F3b4AYmPIva0S31rGQ0Fgyq8QrcgDw8x1hTwAjqzm+0iYwwrRF+g73hajbZ7l7tLaP0SuR2y2KVZxLY/yPEoCuIJrjjGM0xlh4iu5i/bvkoILHiFiKPoBKN2NDQQR5+/R76QJoiQWnUKFVCTHhDSvVUozLhgbOx0ATbTjFe+Y5kKbo7V3Odxi8VWseETrTHvP+CJUtv1bwCwQY+LlKHWB2h+AUzzPz3J7LnZ8jlesLb2PsYK3gG59ATE2JAKdR+792t//XMUAlXjDAxAvxgNXcIPxvdMh+lFxd3apn90Q00Q1F/bj7lzoAgOGcoD2tj5Hm5+5Rt8EENjfyFtt/F+nM36DneMAcUE8+M21d2J3rY7FDcpR7vkQEOuNHbcy0jq+le9cUJZz4m4EtPW98BqbYLs9S1/82dyvZoK/+J3FcfsHI5LZ1ZxiH8UAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.633,98.039l-.007,0,31.669-6.952ZM42.612,90.58l-2.317.509,2.277-.5.041-.009Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "af"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.299,
    height: 7.748,
    transform: "translate(8.457 90.46)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ag",
    width: 1,
    height: 1,
    patternTransform: "matrix(1, 0, 0, -1, 0, 15.495)",
    viewBox: "0 0 34.299 7.748"
  }, /*#__PURE__*/React.createElement("image", {
    preserveAspectRatio: "none",
    width: 34.299,
    height: 7.748,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAJCAYAAAC47pUJAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAI6ADAAQAAAABAAAACQAAAAAQBVY4AAABkUlEQVQ4Ec2Ta07DQAyEx0mE6PtQnIyjcQOOwAUQBfpCbWK+2TZVqkqo6i8ibW1vkvrbGScyU//lavL1KRWhjEpRPUj1QmrmxKmyniiaiVSNqb3Ivc71lHdce38qxSPninvP9twM38xuL+W71H4DxJ83C2U3I44VScPcUq8VBuqAIzewYaL7AohDVPdDATM4SZ8a6rAszVQDk4baUrOAzG5HY/LcAUEkz2pU7ke9OgLdAdWYJbHp4nLplQdUAirXNJwpUSpQp9gkqwOE7fNeoJ6hug3PbrDPUBzEFt5o38mmAYzneVAWyESp9gMQoLo5ANhRoLBHqFRyQEpELWJ6ripD2UasuwHqYmbOFEOlCtiJ7qRUdCsU8CwBJttklYCqtqizAwrLUCmwsQAmUAlc/A01gOnl6GPR5PjjLb62HjbVosantN+coADja3LD1A/3PPCAVAYc8aqVwj6iLS9qxbV9hnkpHXuGPnpzmJeHBj/FzgNNl8o99rWTMlO2LJij9Ex5wFEpiSIaUKiULMUV1NsvvGivi/vrBcwAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ah"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.174,98.151l.1,26.713L42.613,90.58Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ai"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.748,
    height: 34.56,
    transform: "translate(35.008 90.46)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aj",
    width: 1,
    height: 1,
    patternTransform: "matrix(1, 0, 0, -1, 0, 69.12)",
    viewBox: "0 0 7.748 34.56"
  }, /*#__PURE__*/React.createElement("image", {
    preserveAspectRatio: "none",
    width: 7.748,
    height: 34.56,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAjCAYAAACpZEt+AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACKADAAQAAAABAAAAIwAAAAAAXUd9AAABQklEQVQ4EaVSQW4CQQxLyuzC/38EL+hjeqnUMrXjZGa2aE+shJbEju0E/Pvr0e38uX+cY0LeJ7RzC0VbCGzUh2P6DsJvihTI93wWgpreV2K39r8haZKHxU8WbNW01NhpPTL4mGDTWSYZGZ5oVLBSwBtZWDV3boFihJvT7LfemeHYnDUUDneg+UHpScLRV3UphsJqMYEixhZVyFskT+UkmLERm+QNaMxnKERj3AOaEXYQqjGvyIXc21xT15Sww9B8g+k+LRSUhAsAOAOkQTNcsgJR0uyKaYIbLDb+mvANyR2NHdUWBI83CO78518ThAJIAqkGgtktmpqkrLzpry0cniULz9g8QYVE2phKUEEpTzts4VSI9JSfgBeBB9FKr+BisYClUiF5jPJzv4QaVes7RrkOj/MKkoiQ271C8q2geQ9vn39eh4AlT9NezgAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ak"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.159,126.355l.032-.008Zm.032-.008ZM61.545,115.8,26.211,131.83,61.544,115.8l-10.352,10.55h0l-5.334,24.915v.05L61.545,115.8h0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: -0.546,
    y1: 1.549,
    x2: -0.522,
    y2: 1.549,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#757b7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    stopColor: "#6b7074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463,
    stopColor: "#505457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.845,
    stopColor: "#262629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131215"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "am"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.211,131.83l19.5.067.037-.038-19.532-.029,24.947-5.475-24.721,5.424L61.546,115.8Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: -0.63,
    y1: 2.372,
    x2: -0.604,
    y2: 2.372,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#35383b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364,
    stopColor: "#696e72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#949a9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a0a5a8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ao"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.211,131.83l19.562.029,5.419-5.512Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: -1.013,
    y1: 4.847,
    x2: -0.974,
    y2: 4.847,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#515659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#464a4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701,
    stopColor: "#292a2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131215"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.437,131.78l24.754-5.433L61.545,115.8Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.545,115.8h0",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "as"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.261,
    height: 0.261,
    transform: "translate(61.385 115.706)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "au",
    width: 1,
    height: 1,
    patternTransform: "matrix(1, 0, 0, -1, 0, 0.522)",
    viewBox: "0 0 0.261 0.261"
  }, /*#__PURE__*/React.createElement("image", {
    preserveAspectRatio: "none",
    width: 0.261,
    height: 0.261,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAAaADAAQAAAABAAAAAQAAAADa6r/EAAAADUlEQVQIHWP4//+/AwAJPAM+xXYXjQAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "av"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.158,126.355l.033-.008L61.544,115.8Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aw"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.621,
    height: 10.795,
    transform: "translate(51.025 115.706)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ax",
    width: 1,
    height: 1,
    patternTransform: "matrix(1, 0, 0, -1, 0, 21.59)",
    viewBox: "0 0 10.621 10.795"
  }, /*#__PURE__*/React.createElement("image", {
    preserveAspectRatio: "none",
    width: 10.621,
    height: 10.795,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAMCAYAAAC0qUeeAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAC6ADAAQAAAABAAAADAAAAAAQVqQsAAABDUlEQVQoFY2Qy07DMBBFL01IUojXqFvUPUj8YD6NHepnuKuixk78qOPYKWFchFoEEo10N9E9Mz5zM88zrv0WYwipfU1eF5u3DbZ8i3Ec/12QvTw9N1IK9Eqd5lfLEnl++xfIs/XjurHGQlFZCgEpJY7HD1RViaIoLiGerR5WzTA4uIOD0YaiCRAQrUCMEWVZnkIUzxhjTQgB3nsMg4dzDmmTsQZ916FtJQL5EMSzqlrS5AGefiRJ71POkCVI9T2EEDxPd/4qBppmcX+nwUwNphgYlbpOot3vsdu9I/82mOnU6TkxRFiCVIJYTeIJInnZncuXUJwiNIk6d4A2hjYx6Lr+Xf4JTZjoQknaGI1PT/HKjkGFIAkAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ay"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.437,131.78l24.721-5.425L61.544,115.8Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "az"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.344,
    height: 16.192,
    transform: "translate(26.302 115.706)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ba",
    width: 1,
    height: 1,
    patternTransform: "matrix(1, 0, 0, -1, 0, 32.384)",
    viewBox: "0 0 35.344 16.192"
  }, /*#__PURE__*/React.createElement("image", {
    preserveAspectRatio: "none",
    width: 35.344,
    height: 16.192,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAARCAYAAAC1tw6GAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAJKADAAQAAAABAAAAEQAAAABgB/YwAAADf0lEQVRIDa2VWY7bMBBEW4u1effkQkGQjxwrN80BgmBmLEvUnqpu0pHzMRgkY4PQavLxdZGOvnz9tkRRJHEcS1EUctrvZX/Yy+l4lNP5LEceT0d5errI+emTHi/nk2zLUiL85oM/31N2uCyLTNMkTXMT55zUbStd10s3DDh20uJei3t1Xcvry4s8ny9yuZzkAuCSYNHHYSlQ6A5cCsfBf86zAfWDuL6XfujFAbJpndxuNeCucr3WavJ43AOs+hCwByDBTKPYyrfIIre2kRHmur4D0KjWHIwRjAbbppHX61WO9UnOKOthv5MiL/4L7AEoAhGzxGxEUazncAYrrczzAhDAwFgPYx0az13nxAG8AVx9OAAKGdxtJc/zfwJ7BAIIgWJvKcDFgJtRQoLRmAIhXwOtebAe1w7PCdY0gNpvZbvdSZ5tQiLedbwD2UqDITWTWOm4+vwKZCkTwNIYQz4BsIchhp5gw0hQQKK8HazxnW3j1BaD/16wRyDCJCxZAPPlw3UUJwgYjniH8FyZretkJNg4yoQ2ojFrCscFACiWebetpKpKqbCtbDZvG1OgsA9pifyACubt0Nr6nThJ1BzBIUxD/uv5GSCDjCgd7bG0vJ4JycwxfzBVFPmbYGZotbosQzC1hlFjPvC8jxZCHzLHgDgYY9YIM6KENDXNouYGgNJoCSCClbDF87+NpVzqdwhfLmaFK82M+cFhRS15W3gIMCuxwbOsMYVpmWZutvOoq3OaWEbmLbem2eO+BluAy/JMstTcpOjGOkZGdNYcMAyGY9iX7sbutghAWAMJ2dJr9MFNtsPAstS6j1VDJUWGDRahpy1mq3CwhayFMhIs/ZMN65jZUTP3wZAXBbMcERYkvmT2jEb5TqKwPMeK9P0sy6wAV+zsLt3oXw1LWSBXBCN04TLpyw6mckkDADtUC5qPkBfeM0t3EzBKMzag5Ul/ywn4FsM2+9XSoz9+uLFyW+B/JkM+lIXkKGOeYaUOhd4zIF+ix5DajGnDymLXiS+PGsO5gdhE1DT6UhiA6URI4oHCKY0RiKHfoFwVrHAfyzLkCP+XaeiUA1N1KGEwEgZXOAWywfR3uGaZ+Gy9ELgtrO0Qil/7eGMEQ44mlg2tQH7ynhmK488BSgf3pYsi22vuYWanaOtrTgA0q0mszzlwgDBR+Lm+G+6zP65KNYaVCLAfvwHceb3CX+nWVQAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.773,131.859l.073,19.453,5.346-24.965Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.192,126.347h0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.261,
    height: 0.261,
    transform: "translate(51.025 126.239)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bf",
    width: 1,
    height: 1,
    patternTransform: "matrix(1, 0, 0, -1, 0, 0.522)",
    viewBox: "0 0 0.261 0.261"
  }, /*#__PURE__*/React.createElement("image", {
    preserveAspectRatio: "none",
    width: 0.261,
    height: 0.261,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAAaADAAQAAAABAAAAAgAAAACdSsUUAAAAEklEQVQIHWP4//8/A9Pxo8ccAB8zBZKUE0IMAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.192,126.347l-5.419,5.512,5.418-5.512Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bi"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.658,
    height: 5.746,
    transform: "translate(45.628 126.239)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bk",
    width: 1,
    height: 1,
    patternTransform: "matrix(1, 0, 0, -1, 0, 11.491)",
    viewBox: "0 0 5.658 5.746"
  }, /*#__PURE__*/React.createElement("image", {
    preserveAspectRatio: "none",
    width: 5.658,
    height: 5.746,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAB6ADAAQAAAABAAAABwAAAADynv1sAAAAaElEQVQIHXWOQQ6AQAgDa+KBAquv1IO/9Af+aC26Hm1CQhhKmXrv2PajGw1OVxFUT/KcIblr6ByAsFowwwNDQJsqB5/eEDIM5wcEdbJARnwwXqdcWRECmfnCCq/cjAFaQ1vWa6pv/3QD3EsOorG2yy4AAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.773,131.859l.073,19.453,5.345-24.964Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bm"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.658,
    height: 25.245,
    transform: "translate(45.628 126.239)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bn",
    width: 1,
    height: 1,
    patternTransform: "matrix(1, 0, 0, -1, 0, 50.491)",
    viewBox: "0 0 5.658 25.245"
  }, /*#__PURE__*/React.createElement("image", {
    preserveAspectRatio: "none",
    width: 5.658,
    height: 25.245,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAbCAYAAACwRpUzAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAB6ADAAQAAAABAAAAGwAAAABXjofvAAABDUlEQVQoFZ2QS1LGMAyD3Uccp7fiwGwYLsCNOECaINlJw4J/Qzt9+ZNkTbfeu7w6ToL3j8+/FF/7Kxfn/4Os4jsZwQ+WmwX5dFjv5pQCkebCNmG7b+HHPHoLsTtvQI+DgGdrIYzYWtcuuBzNWHeOIUGHcxWqEfu76VOo3ox1S0SyGdy+k205bR0t8TKLP20XdE7JcnoqbnMvk8M52kWcy0STDohC/odIt12KqmRc4yegkGxy7AA5S8almgMSnMchxQIQpulUPeGwx6E5rZ2XXWKmHqW+D1BTxFpBnJoPMoYETyHzSDhTAIObCd7WvB3UeQhG44C+D+A8JZcCV5arWDiR/8YdSocVKQDF7PsHQKyiklaXNb4AAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.416,32.846,83.777,57.957l-12.7,59.34v.087L79.592,98.1l.025-.057,2.862-6.479,3.31-7.494.466-1.055,0-.006,22.158-50.163Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bp",
    x1: -1.158,
    y1: 1.633,
    x2: -1.139,
    y2: 1.633,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45c2ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#40bdec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#1d9eda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784,
    stopColor: "#078bcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0085cb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.312,71.008l46.405.17.1-.1-46.505-.068.556-.122,83.548-38.04Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "br",
    x1: -0.218,
    y1: 2.334,
    x2: -0.207,
    y2: 2.334,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009fdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    stopColor: "#06a1e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#1aa9e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#39b5e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#65c7ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#86d4f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96daf6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.859,70.89l.008,0-.555.122,46.571.068L83.777,57.957Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bt",
    x1: -0.388,
    y1: 4.759,
    x2: -0.371,
    y2: 4.759,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1cbbed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#18b4e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432,
    stopColor: "#0b9ad8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#028ace"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0085cb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.883,71.076l.172,46.308L83.777,57.957Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.776,57.957",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.7,57.972l.073-.015,24.639-25.111Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bx"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.984,
    height: 25.333,
    transform: "translate(83.583 32.744)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "by",
    width: 1,
    height: 1,
    patternTransform: "matrix(1, 0, 0, -1, 0, 50.665)",
    viewBox: "0 0 24.984 25.333"
  }, /*#__PURE__*/React.createElement("image", {
    preserveAspectRatio: "none",
    width: 24.984,
    height: 25.333,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAGqADAAQAAAABAAAAGgAAAABvAZQwAAAC2ElEQVRIDbWWa1PbMBBFFb9kJUB/c/9uP7SUBmz52XPXFnUYT4dAyIyRLYs9und3lRzmeXZ87I9uvuqTKfC5m9z4xahCoJ/Pgwtl5k5V5jxjftDsbT8G+gWoBdD0mQEDQIFvCTTQ73Z07TC5MGSuLf4Bb6lwAb0MrkZBHGYXihllkymMKPSoO/Hus5Ya6LEZnSe4YE1xcDWqWgBmZZe5F+aPZufyrviApwb6EwfXjRnX7CqCxHJerKxyG2uUSZ2AoZwWKO+u4S0gctRhWSwm51EjC+vy4DobUZdjJYoEbIC1srjn0hy09yg00FPEOtTU4xK8AiiFEbiKRFZKrW2EgpG6a6vUQOcORdNMsIPzOfYNAIF0AKMUboAVuQwbSy+AuKB3e5Ya6BFFgR33CgrIs1IKBK6waQv0FEuyNOVSlhpQBYOle23xap1Zg02WI4A1wLgq3AOapQCsLdbieQUyr4bfNr6BfjSD9UoAEFZYiyo9RwqhIi+eUZsoGRVc963Ur20hpcplY6rWCqU1guxk/QLqZd3kHlh4x6XCCICiRj0TsGPUs2ztZSt5U9FEFQf2CiQrPRvtCKzNtShTlQbmDaSvihf+uaEgnliYgMpbx3MFRPeWu3UD2oynaEqANZu0Kl2ByqGKxgoJhQIaKJ3Tb4HfAJykSEAuNbNgOqasSrmvmO8BtgKubaG1ppA5O0OTdQmUxgSMKFTOZKd2t9i4WkowzZmtG+C2LSosV+PL2gtFCZTGEUvPBHwGeAZ4T2ApNEuZr5lT7tQWZYZV+aJeja+2SI3vUfZfUAJKYQKeVuAddtQErqWMOVWhqdtpfJ0o7wLtAWXpPSB9haS2UA5V4nrW+eilkHUl41WgLTBVaRhG91Dm7rgCrPFRqaKRZTp0lasPgS6A/KhpOCsvFAJSH6paI6Oq9FOgCyBB1YdvG/8ISI1+E9AeMDW+tcAG9D0tvsWY+nB70vwFKXwljuuF/PkAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.87,70.886,83.7,57.972l24.712-25.126Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ca"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.832,
    height: 38.303,
    transform: "translate(24.735 32.744)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cb",
    width: 1,
    height: 1,
    patternTransform: "matrix(1, 0, 0, -1, 0, 76.607)",
    viewBox: "0 0 83.832 38.303"
  }, /*#__PURE__*/React.createElement("image", {
    preserveAspectRatio: "none",
    width: 83.832,
    height: 38.303,
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.7,57.972,24.87,70.886l-.011,0L83.777,57.957Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.196,
    height: 13.232,
    transform: "translate(24.735 57.815)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ce",
    width: 1,
    height: 1,
    patternTransform: "matrix(1, 0, 0, -1, 0, 26.464)",
    viewBox: "0 0 59.196 13.232"
  }, /*#__PURE__*/React.createElement("image", {
    preserveAspectRatio: "none",
    width: 59.196,
    height: 13.232,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAOCAYAAABzTn/UAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAPKADAAQAAAABAAAADgAAAABz9iCAAAAEHElEQVRIDbWWDXarNhCFZePw5/TldAvdSffZlXUXPW1iwDb0+0Zgg5v0pT0vnBBJIwnPnXtnpN00TemX336fEs/Ol38FbbXfpeNhn56fitQedqmh3/JqrxjX9Ev6JW1d0PJqLwvs9OtYc59f5hrsFfPNU17jd+nG7+rDVz+HzQ+INk1p5P9pnFJ3GdMroXi+Ah5jd51SK5hxnwbGOl4xPzAfIEdBp1TSDrwd9vrKvIGwX0zz2n3qHWPvDlN8p30ygBtvvmSwBcxPBMu0Ug75AXyg8wbYV9iQ9SN93wona1uBYxdktQSCcUnQDMwSkM5gzcD7q3sdq5qJAExZFSikUmJf9NwAZ6DCnB/YDsIDOkwAuofxN1kH6DfANLzKWVnWAoWxAIitZ5ylPUYgZNjxoDoAVI7YsQnUgPXYVUNdXAO43/wKxm+AF5y2K9hrM4wjcyzn85hOONri4BFnZbvhSzUM2w6TAbgiZcDJopJmnVInXgDOEg+pY6upBQLvLq7NwE2nmm/96By/A57zd4MwBL6FrxJGgeN4f76mV0A/j0XkeAtL5nnjHCxWrLOwyaptjTKG60ihy+BNAZk3AJVr2NPDvPmt/CsC0B0y8PoHSf0OGCCCWT8ThkfbZl6ZW5QmgY8wXVDVqebKPWQOSBwfGFc4PBC7yHeBYr8I/AaYOYpWlnyed2+vAlRJcQeu1HO6rb35XD8Ar0HZn+b8ldv9e19+sIGb4saLDP8C3E8Asaq3s1w9ipSnBU1WBVHCqIHIUjcFYFZWzW3zF7Y7iplgtXd8Q8YbGPdI83j8P8BvDO/eydxsW4fjO1G8SX1MfwLuG6COOCpAZR45iWwq3jNBOgdw7Oy7yL62mCMQrJdxykU646VF0P0GKU4DghBnPe1/KW43wAsUfnN+gutlEO270B/YdmEwjsRlvbkAHMZk/IizVuOQNQzKfJzZpEW+zDgWHEGZpS5QK3/JGW5uu06bR1mWuqxj/yTwDFgJPzD8vfzdRMKB0Qjw95CliWMM508UN8/rF87cZ5zN+U0Vt5pHMZrSme0LsGDSs5m9HncD+yx0ccY7BrypEMGQfb4tYIE3tMT3w2fDcHAqeDortz/cvEyY8+vnH2M+Fjc39PkHDr/wtlbkcDQfaZHnssTaqN5WdbwzCBUA842OPeyLc9yWW9pyqfGy4vdOoG3of8T4BvDaaRn/TMFa7/movwRw4ptvFKUT5doK/DOMtABqYPKI1L16CtK5fJwp4T15nU+Dkrl8e2Pe04G9+RKDHbBR9Eglg9JwWlgDHoEHYMD9unU2uN6YthzOUw/Mbjb8ywA/46rak9PezV+eqMzYWvKoJw1Cyki9xvELN/sz0i+ReJUAbyFDBc5F4QOo8pbhC4FTHRbDgcBmmQuaALCGv/Q3PY37g1MKEToAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.145,
    height: 59.719,
    transform: "translate(70.786 57.815)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ch",
    width: 1,
    height: 1,
    patternTransform: "matrix(1, 0, 0, -1, 0, 119.437)",
    viewBox: "0 0 13.145 59.719"
  }, /*#__PURE__*/React.createElement("image", {
    preserveAspectRatio: "none",
    width: 13.145,
    height: 59.719,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAA9CAYAAACdpljSAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAADqADAAQAAAABAAAAPQAAAAB4udmWAAADEUlEQVRIDe2VXXIaMRCEdwHj3P8OOUjukWvkzWbTX8+0JAx2VfycLWOEpv9mJOz9OI7tO88F0s/ff/6ZffqOG5z/xC8m9+3h+By/EB6lY6ujzu+nxHvQtq2367bt27bvm4n3QH3qe3SzXwGz5y3VTbz1btQQXYHr+taiJr6DzKNC17aADkXjWQU66jZBIAJk3Y9jtz4CwzEu4Ko3LRK5U2R/IRYIEpuJtAKp8cSghzNdQlpBXoehDwhW1N5caveuUvtYG8OJk+M9AeJaz+FBmviWuasSgcDqjPfheBz7jDrBqK0g+ukzjFKLjx6LXGpg0tMUJU3PWVqT2IoPQF+GlulzJa6JtDjViDaBri1xI2yiOhu3hMIhYFPHsPI5c+yo98CASB8g63V/9PgV6CNp3Jzqg3I9q3LNsY6E9V2PVZz3Ffo4v1apt3n1aqoaRsg1nHKmq7jznjVVE9+88zloytSKP17tOEkB8V4OqtmuPqUFE70/GCtwtsBBF7WOqBzdGNegplduvRZ69D/Eu8dxrT4B2Uni3Cge/m/Y8V0VF72ttZtir4BVU1RZn8S65C85X9aA4Gbtb5G4iXoR6SrSK2SA9NYmA5TPROGbddXr5bRvV71eQnTUJWscEBXmkZSoEPMsS/VSpFe74LZtZ5Fwnue4MBKtCBXxBRciQpRgEZsEQT9u3kM4C6wNHACfBCjXJhIT0rlJAHHDwU6q+QgcVfFxDgllxmxCK18ga01tvJpsIqOGcFU01gwgg1gJtW4hHH8QTSSfTztkGNpe3Ha3c07UkJ71gwuCpGDNu8Vw9BV60k8SqGQSU3XcOHKNopiCz4p9CRPtrINiyhVdaxw/6weRckvMimpxE7EmzqKI8ujHa+qVwDfojtg9DBcJjfVw77gQceO2POsnvVeCSrVEnaTclEQFZNfRBkY9HIpRJr9+3E/tV6IpcKp5uEcUWjECazRaoJWHcwwpMZ9FO2vTCfQ+vo8PURWdPb/unIo8jqO+Pj3mJpSDhub+JaJFxIjtm6ONX6VeLtXLoi5gBCBxh/8C5/A58MuRpwsAAAAASUVORK5CYII="
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-101.312 -130.846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.948,139.222a57.177,57.177,0,0,1-17.057,2.881c-9.325,0-16.072-2.35-20.772-6.9-4.7-4.4-7.278-11.069-7.2-18.574.075-16.981,12.433-26.685,29.187-26.685,6.6,0,11.675,1.289,14.176,2.5l-2.426,9.249a28.309,28.309,0,0,0-11.9-2.2c-9.628,0-16.9,5.459-16.9,16.527,0,10.538,6.6,16.754,16.071,16.754a15.47,15.47,0,0,0,5.686-.758V121.331H140.92v-9.022h19.028Z",
    transform: "translate(93 98)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.15,91.158A94.524,94.524,0,0,1,183.766,90.1c7.127,0,12.206,1.364,15.617,4.093a14.936,14.936,0,0,1,5.459,11.827c0,5-1.668,9.249-4.7,12.13-3.942,3.714-9.78,5.382-16.6,5.382a29.2,29.2,0,0,1-3.942-.227v18.27H168.15Zm11.447,23.2a17.694,17.694,0,0,0,3.866.3c6.141,0,9.932-3.108,9.932-8.339,0-4.7-3.26-7.5-9.022-7.5a19.721,19.721,0,0,0-4.776.454Z",
    transform: "translate(93 98)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.867,129.669a29.479,29.479,0,0,0,12.812,3.184c5.307,0,8.112-2.2,8.112-5.534,0-3.184-2.427-5-8.567-7.2-8.491-2.957-14.025-7.657-14.025-15.087,0-8.718,7.278-15.389,19.332-15.389a31.3,31.3,0,0,1,13.039,2.578l-2.577,9.324a24.3,24.3,0,0,0-10.69-2.426c-5,0-7.429,2.275-7.429,4.928,0,3.26,2.88,4.7,9.476,7.2,9.021,3.335,13.267,8.036,13.267,15.238,0,8.567-6.6,15.844-20.621,15.844-5.837,0-11.6-1.516-14.479-3.108Z",
    transform: "translate(93 98)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.037,176.546H10.27A1.655,1.655,0,0,1,8.626,174.9V162.422a1.655,1.655,0,0,1,1.644-1.644h5.564a1.509,1.509,0,1,1,0,3.018h-3.92v2.726h3.4a1.5,1.5,0,0,1,1.486,1.487,1.394,1.394,0,0,1-.439,1.036,1.45,1.45,0,0,1-1.047.428h-3.4v4.055h4.122a1.509,1.509,0,1,1,0,3.018",
    transform: "translate(101.353 92.291)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.037,176.546H10.27A1.655,1.655,0,0,1,8.626,174.9V162.422a1.655,1.655,0,0,1,1.644-1.644h5.564a1.509,1.509,0,1,1,0,3.018h-3.92v2.726h3.4a1.5,1.5,0,0,1,1.486,1.487,1.394,1.394,0,0,1-.439,1.036,1.45,1.45,0,0,1-1.047.428h-3.4v4.055h4.122a1.509,1.509,0,1,1,0,3.018Z",
    transform: "translate(101.353 92.291)",
    fill: "none",
    stroke: "#0f1212",
    strokeWidth: 0.469
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.482,170.86v-8.717a1.644,1.644,0,0,1,3.289,0v8.65a5.748,5.748,0,0,1-1.724,4.381,6.1,6.1,0,0,1-8.312,0,5.748,5.748,0,0,1-1.723-4.381v-8.65a1.644,1.644,0,0,1,3.288,0v8.717a3.092,3.092,0,0,0,.7,2.174,2.751,2.751,0,0,0,3.785,0,3.092,3.092,0,0,0,.7-2.174",
    transform: "translate(99.421 92.301)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.482,170.86v-8.717a1.644,1.644,0,0,1,3.289,0v8.65a5.748,5.748,0,0,1-1.724,4.381,6.1,6.1,0,0,1-8.312,0,5.748,5.748,0,0,1-1.723-4.381v-8.65a1.644,1.644,0,0,1,3.288,0v8.717a3.092,3.092,0,0,0,.7,2.174,2.751,2.751,0,0,0,3.785,0A3.092,3.092,0,0,0,71.482,170.86Z",
    transform: "translate(99.421 92.301)",
    fill: "none",
    stroke: "#0f1212",
    strokeWidth: 0.469
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.782,160.5a7.981,7.981,0,0,1,5.834,2.208,1.5,1.5,0,0,1,.45,1.1,1.475,1.475,0,0,1-.45,1.081,1.5,1.5,0,0,1-1.1.45,1.574,1.574,0,0,1-1.126-.45,5.038,5.038,0,0,0-3.537-1.374,4.918,4.918,0,0,0-3.615,1.476,5.277,5.277,0,0,0,0,7.32,4.914,4.914,0,0,0,3.615,1.476,5.034,5.034,0,0,0,3.537-1.374,1.578,1.578,0,0,1,1.126-.45,1.5,1.5,0,0,1,1.1.45,1.478,1.478,0,0,1,.45,1.081,1.5,1.5,0,0,1-.45,1.1,7.98,7.98,0,0,1-5.834,2.207,8.19,8.19,0,0,1-5.856-2.342,8.1,8.1,0,0,1,0-11.623,8.191,8.191,0,0,1,5.856-2.343",
    transform: "translate(98.482 92.301)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.782,160.5a7.981,7.981,0,0,1,5.834,2.208,1.5,1.5,0,0,1,.45,1.1,1.475,1.475,0,0,1-.45,1.081,1.5,1.5,0,0,1-1.1.45,1.574,1.574,0,0,1-1.126-.45,5.038,5.038,0,0,0-3.537-1.374,4.918,4.918,0,0,0-3.615,1.476,5.277,5.277,0,0,0,0,7.32,4.914,4.914,0,0,0,3.615,1.476,5.034,5.034,0,0,0,3.537-1.374,1.578,1.578,0,0,1,1.126-.45,1.5,1.5,0,0,1,1.1.45,1.478,1.478,0,0,1,.45,1.081,1.5,1.5,0,0,1-.45,1.1,7.98,7.98,0,0,1-5.834,2.207,8.19,8.19,0,0,1-5.856-2.342,8.1,8.1,0,0,1,0-11.623A8.191,8.191,0,0,1,97.782,160.5Z",
    transform: "translate(98.482 92.301)",
    fill: "none",
    stroke: "#0f1212",
    strokeWidth: 0.469
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.728,160.779h7.929a1.509,1.509,0,1,1,0,3.018h-2.321v11.375a1.644,1.644,0,0,1-3.289,0V163.8h-2.32a1.509,1.509,0,1,1,0-3.018",
    transform: "translate(96.431 92.291)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.728,160.779h7.929a1.509,1.509,0,1,1,0,3.018h-2.321v11.375a1.644,1.644,0,0,1-3.289,0V163.8h-2.32a1.509,1.509,0,1,1,0-3.018Z",
    transform: "translate(96.431 92.291)",
    fill: "none",
    stroke: "#0f1212",
    strokeWidth: 0.469
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.119,175.162v-13.02a1.644,1.644,0,0,1,3.289,0v13.02a1.644,1.644,0,0,1-3.289,0",
    transform: "translate(95.299 92.301)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.119,175.162v-13.02a1.644,1.644,0,0,1,3.289,0v13.02a1.644,1.644,0,0,1-3.289,0Z",
    transform: "translate(95.299 92.301)",
    fill: "none",
    stroke: "#0f1212",
    strokeWidth: 0.469
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.357,162.841a8.633,8.633,0,0,0-11.826,0,8.08,8.08,0,0,0,0,11.623,8.618,8.618,0,0,0,11.814,0,8.067,8.067,0,0,0,.012-11.623m-2.061,9.709a5.589,5.589,0,1,1,1.577-3.9,5.279,5.279,0,0,1-1.577,3.9",
    transform: "translate(94.555 92.301)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.357,162.841a8.633,8.633,0,0,0-11.826,0,8.08,8.08,0,0,0,0,11.623,8.618,8.618,0,0,0,11.814,0,8.067,8.067,0,0,0,.012-11.623Zm-2.061,9.709a5.589,5.589,0,1,1,1.577-3.9A5.279,5.279,0,0,1,212.3,172.549Z",
    transform: "translate(94.555 92.301)",
    fill: "none",
    stroke: "#0f1212",
    strokeWidth: 0.469
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.3,176.4l-8.267-9.393v8.155a1.644,1.644,0,0,1-3.289,0V161.534a1.026,1.026,0,0,1,.282-.743.942.942,0,0,1,.71-.293,1.088,1.088,0,0,1,.833.405l8.267,9.415v-8.176a1.644,1.644,0,0,1,3.289,0V175.77a1.031,1.031,0,0,1-.282.744.945.945,0,0,1-.71.292,1.088,1.088,0,0,1-.833-.405",
    transform: "translate(93.501 92.301)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.3,176.4l-8.267-9.393v8.155a1.644,1.644,0,0,1-3.289,0V161.534a1.026,1.026,0,0,1,.282-.743.942.942,0,0,1,.71-.293,1.088,1.088,0,0,1,.833.405l8.267,9.415v-8.176a1.644,1.644,0,0,1,3.289,0V175.77a1.031,1.031,0,0,1-.282.744.945.945,0,0,1-.71.292A1.088,1.088,0,0,1,241.3,176.4Z",
    transform: "translate(93.501 92.301)",
    fill: "none",
    stroke: "#0f1212",
    strokeWidth: 0.469
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.318,174.644l-5.585-13.425a1.073,1.073,0,0,0-2.027,0l-5.586,13.425a1.617,1.617,0,0,0-.113.585,1.539,1.539,0,0,0,.45,1.115,1.485,1.485,0,0,0,1.1.462,1.5,1.5,0,0,0,1.508-1.081l.834-2.186h5.609l.855,2.186a1.5,1.5,0,0,0,1.509,1.081,1.483,1.483,0,0,0,1.1-.462,1.539,1.539,0,0,0,.45-1.115,1.617,1.617,0,0,0-.113-.585m-8.874-3.424,2.275-5.879,2.252,5.879Z",
    transform: "translate(97.469 92.301)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.318,174.644l-5.585-13.425a1.073,1.073,0,0,0-2.027,0l-5.586,13.425a1.617,1.617,0,0,0-.113.585,1.539,1.539,0,0,0,.45,1.115,1.485,1.485,0,0,0,1.1.462,1.5,1.5,0,0,0,1.508-1.081l.834-2.186h5.609l.855,2.186a1.5,1.5,0,0,0,1.509,1.081,1.483,1.483,0,0,0,1.1-.462,1.539,1.539,0,0,0,.45-1.115A1.617,1.617,0,0,0,131.318,174.644Zm-8.874-3.424,2.275-5.879,2.252,5.879Z",
    transform: "translate(97.469 92.301)",
    fill: "none",
    stroke: "#0f1212",
    strokeWidth: 0.469
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,162.963a8.381,8.381,0,0,0-5.89-2.185h-2.95a1.653,1.653,0,0,0-1.644,1.644V174.9a1.653,1.653,0,0,0,1.644,1.644h2.95A8.376,8.376,0,0,0,45,174.361a8.022,8.022,0,0,0,0-11.4m-2.016,9.472a5.216,5.216,0,0,1-3.807,1.408H37.462V163.481h1.712a5.216,5.216,0,0,1,3.807,1.407,5.658,5.658,0,0,1,0,7.546",
    transform: "translate(100.433 92.291)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,162.963a8.381,8.381,0,0,0-5.89-2.185h-2.95a1.653,1.653,0,0,0-1.644,1.644V174.9a1.653,1.653,0,0,0,1.644,1.644h2.95A8.376,8.376,0,0,0,45,174.361a8.022,8.022,0,0,0,0-11.4Zm-2.016,9.472a5.216,5.216,0,0,1-3.807,1.408H37.462V163.481h1.712a5.216,5.216,0,0,1,3.807,1.407,5.658,5.658,0,0,1,0,7.546Z",
    transform: "translate(100.433 92.291)",
    fill: "none",
    stroke: "#0f1212",
    strokeWidth: 0.469
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.778,
    height: 66.469,
    transform: "translate(74.82 72.664) rotate(-12.025)",
    fill: "url(#b)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.901,
    height: 50.379,
    transform: "translate(42.856 74.406) rotate(-23.389)",
    fill: "url(#d)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.739,
    height: 19.506,
    transform: "translate(50.942 88.938) rotate(-13.41)",
    fill: "url(#f)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.368,
    height: 18.717,
    transform: "translate(96.641 69.829)",
    fill: "url(#i)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.634,
    height: 28.205,
    transform: "translate(53.375 69.829)",
    fill: "url(#l)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.527,
    height: 9.75,
    transform: "translate(53.375 88.284)",
    fill: "url(#o)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.663,
    height: 43.962,
    transform: "translate(87.24 88.284)",
    fill: "url(#r)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.227,
    height: 52.183,
    transform: "matrix(0.978, -0.208, 0.208, 0.978, 25.349, 78.215)",
    fill: "url(#t)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.305,
    height: 39.552,
    transform: "translate(0.256 79.582) rotate(-23.389)",
    fill: "url(#v)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.12,
    height: 15.318,
    transform: "matrix(0.973, -0.232, 0.232, 0.973, 6.604, 90.988)",
    fill: "url(#x)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.538,
    height: 14.712,
    transform: "translate(42.407 76.01)",
    fill: "url(#aa)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ab)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ac)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.401,
    height: 22.198,
    transform: "translate(8.544 76.009)",
    fill: "url(#ad)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#af)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.299,
    height: 7.748,
    transform: "translate(8.457 90.46)",
    fill: "url(#ag)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ah)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.748,
    height: 34.56,
    transform: "translate(35.008 90.46)",
    fill: "url(#aj)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ak)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.959,
    height: 42.097,
    transform: "translate(18.974 117.338) rotate(-12.025)",
    fill: "url(#al)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#am)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.823,
    height: 28.804,
    transform: "matrix(0.918, -0.397, 0.397, 0.918, 20.345, 118.334)",
    fill: "url(#an)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ao)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.578,
    height: 11.155,
    transform: "translate(24.968 126.643) rotate(-13.41)",
    fill: "url(#ap)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aq)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ar)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#as)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#as)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.261,
    height: 0.261,
    transform: "translate(61.385 115.706)",
    fill: "url(#au)"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#av)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aw)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.621,
    height: 10.795,
    transform: "translate(51.025 115.706)",
    fill: "url(#ax)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ay)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#az)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.344,
    height: 16.192,
    transform: "translate(26.302 115.706)",
    fill: "url(#ba)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bb)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bd)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.261,
    height: 0.261,
    transform: "translate(51.025 126.239)",
    fill: "url(#bf)"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bb)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bh)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bi)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bi)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.658,
    height: 5.746,
    transform: "translate(45.628 126.239)",
    fill: "url(#bk)"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bl)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bm)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.658,
    height: 25.245,
    transform: "translate(45.628 126.239)",
    fill: "url(#bn)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bo)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.135,
    height: 90.463,
    transform: "translate(53.848 36.515) rotate(-12.025)",
    fill: "url(#bp)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bq)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92.41,
    height: 68.569,
    transform: "matrix(0.918, -0.397, 0.397, 0.918, 10.346, 38.887)",
    fill: "url(#br)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bs)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.886,
    height: 26.552,
    transform: "translate(21.352 58.663) rotate(-13.41)",
    fill: "url(#bt)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bu)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bv)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.776,57.957Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bw)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bx)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.984,
    height: 25.333,
    transform: "translate(83.583 32.744)",
    fill: "url(#by)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bz)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ca)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.832,
    height: 38.303,
    transform: "translate(24.735 32.744)",
    fill: "url(#cb)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cd)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.196,
    height: 13.232,
    transform: "translate(24.735 57.815)",
    fill: "url(#ce)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bu)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cg)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.145,
    height: 59.719,
    transform: "translate(70.786 57.815)",
    fill: "url(#ch)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsLogo);
export default __webpack_public_path__ + "static/media/GPS-Logo.c93c799cc53a2cce8582372b3fe274a9.svg";
export { ForwardRef as ReactComponent };